import { DeletedAccountExistsMessage } from 'components/Auth/Login/partials/Messages';
import i18n from 'i18n/config';

import { BACKEND_ERROR_CODES } from '../hooks/useVerifyUsingOauth/useVerifyUsingOauth.constants';
import { AllErrors } from '../hooks/useVerifyUsingOauth/useVerifyUsingOauth.types';

const OauthErrorMessage = ({ error }: { error: AllErrors }) => {
  switch (error.code) {
    case BACKEND_ERROR_CODES.OAUTH_NOT_ACTIVE:
      return i18n.t('auth:twoFaFaceAuth.oauthNotActive');
    case BACKEND_ERROR_CODES.MFA_ALREADY_DISABLED:
      return i18n.t('auth:twoFaFaceAuth.mfaAlreadyDisabled');

    case BACKEND_ERROR_CODES.USER_NOT_FOUND:
      return i18n.t('errors:custom.user_not_found');
    case BACKEND_ERROR_CODES.DELETED_ACCOUNT_EXISTS:
      return (
        <DeletedAccountExistsMessage
          email={error.context.email}
          userId={error.context.user_id}
        />
      );
    default:
      return i18n.t('errors:defaultMessage');
  }
};

export default OauthErrorMessage;
